import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import styled from 'styled-components';
import { useIsAboveBreakPoint } from 'hooks/responsive';
import { type SizesUnion, sizes } from 'variables';

interface IDisplayBreakpoint extends HTMLAttributes<HTMLDivElement> {
    up: SizesUnion;
    negate?: boolean;
    removeFromDOM?: boolean;
    children: ReactNode;
}

const Wrapper = styled.div`
    display: contents;
`;

const WhenBreakpoint = forwardRef<HTMLDivElement, IDisplayBreakpoint>((props, ref) => {
    const { up, negate, children, removeFromDOM = false, ...restProps } = props;
    const value = useIsAboveBreakPoint(sizes[up]);
    const hidden = (!value && !negate) || (value && negate);

    if (hidden && removeFromDOM) {
        return null;
    }

    return (
        <Wrapper ref={ref} hidden={hidden} {...restProps}>
            {children}
        </Wrapper>
    );
});

export default WhenBreakpoint;
